import { render } from "./DetalleCotizacion.vue?vue&type=template&id=5cb38827&scoped=true"
import script from "./DetalleCotizacion.vue?vue&type=script&lang=js"
export * from "./DetalleCotizacion.vue?vue&type=script&lang=js"

import "./DetalleCotizacion.vue?vue&type=style&index=0&id=5cb38827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb38827"]])

export default __exports__